import { Injectable } from '@angular/core';
import { UtmTrackingsPage } from '../api/dashboard/utmtrackings-service/utmtrackings-model';

@Injectable()
export class UtmPagingService {
  public page: UtmTrackingsPage = {
    'pageNumber': 0,
    'size': 10,
    'filterModel':  {
      'searchValue': '',
      'locationDateTimeFilter': null,
      'ticketHolderFilter': null,
      'accountOwnerFilter': null,
      'medium': '',
      'source': '',
      'campaign': '',
      'term': '',
      'content': '',
      'campaingId': ''
    },
    'sortProperty': '',
    'sortDirection': '',
    'totalElements': 0,
    'totalPages': 0,
    'eventId': null
  };

}
